<template>
  <div class="menuSet" style="padding: 0 1em;">
    <div style="border: 2px #E6E9EC solid; padding: 0.5em; text-align:left;">
      <img src="@/assets/images/lp.gif" style="height: 22px; width: 22px;" />{{setting.sysTitle[0].codeName}}&nbsp;
      <table>
        <tbody v-for="(items, index) in menuInfo" :key="index">
          <tr>
            <td style="text-align:left; width:1.5em; padding: 0;"
              v-bind:class="{ 'ncut-row-selectd': items.mId === curID, '': items.mId != curID }"
              @click="itemClick(items)">
              <img src="@/assets/images/treeLine4.gif" style=" height: 1.5em;" v-show="((menuInfo.length-1) == index) && (null != items.subMenu && 0 < items.subMenu.length) && (!items.flag)" />
              <img src="@/assets/images/treeLine6.gif" style=" height: 1.5em;" v-show="((menuInfo.length-1) == index) && (null != items.subMenu && 0 < items.subMenu.length) && (items.flag)" />
              <img src="@/assets/images/tminus2.gif" style=" height: 1.5em;" v-show="((menuInfo.length-1) > index) && (null != items.subMenu && 0 < items.subMenu.length) && (!items.flag)" />
              <img src="@/assets/images/tminus1.gif" style=" height: 1.5em;" v-show="((menuInfo.length-1) > index) && (null != items.subMenu && 0 < items.subMenu.length) && (items.flag)" />
              <img src="@/assets/images/treeLine2.gif" style=" height: 1.5em;" v-show="((menuInfo.length-1) == index) && ((null == items.subMenu) || (0 == items.subMenu.length))" />
              <img src="@/assets/images/treeLine.gif" style=" height: 1.5em;" v-show="((menuInfo.length-1) > index) && (null == items.subMenu || 0 == items.subMenu.length)" />
            </td>
            <td style="text-align:left; width:1.5em; padding: 0;"
              v-bind:class="{ 'ncut-row-selectd': items.mId === curID, '': items.mId != curID }"
              @click="itemClick(items)">
              <img class="tools-btn" style=" height:1.25em;"
                src="@/assets/images/folder.png"
                v-show="null!=items.subMenu && items.subMenu.length>0 && items.flag" />
              <img class="tools-btn" style="height:1.25em;"
                src="@/assets/images/folder_close.png"
                v-show="null!=items.subMenu && items.subMenu.length>0 && !items.flag" />
              <img class="tools-btn" style=" height: 1.25em;"  
                src="@/assets/images/ic_format_color_text_black_24dp.png" 
                v-show="null==items.subMenu||items.subMenu.length==0"/>
            </td>
            <td style="text-align:left; width:21.5em; padding: padding: 0 0.5rem;"
              v-bind:class="{ 'ncut-row-selectd': items.mId === curID, '': items.mId != curID }"
              @click="itemClick(items)">
              <table>
                <tr>
                  <td>
                    <b-form-input placeholder="請輸入繁體選單名稱" style="width:21.5em"
                          v-model="items.title[0]"
                          size="small" maxlength="15" show-word-limit
                          @change="setChangeFlag(items)"/> 
                  </td>
                  <!-- <td>
                    <el-input placeholder="請輸入簡體選單名稱" style="width:14em"
                          v-model="items.title[1]"
                          size="small" maxlength="15" show-word-limit
                          @change="setChangeFlag(items)"/>&nbsp;
                  </td> -->
                  <!-- <td>
                    <b-form-input placeholder="請輸入英文選單名稱" style="width:14em"
                          v-model="items.title[2]"
                          size="small" maxlength="15" show-word-limit
                          @change="setChangeFlag(items)"/> 
                  </td> -->
                </tr>
              </table>
            </td>
            <td style="text-align:left; width:12em; padding: 0 0.5rem;"
              v-bind:class="{ 'ncut-row-selectd': items.mId === curID, '': items.mId != curID }">                        
              <b-form-radio-group
                id="btn-radios-2"
                v-model="items.sort"
                @change="setChangeFlag(items)"
                v-on:focus="itemClick(items)"
                :options="options"
                button-variant="outline-primary"
                placeholder="請選擇..."
                name="radio-btn-outline"
                buttons
                ></b-form-radio-group>                     
            </td>
          </tr>
          <tr v-if="items.flag">
            <td colspan="4" style="padding: 0;">
              <table>
                <tbody>
                  <tr v-for="(node, index2) in items.subMenu" :key="node.mId" 
                    :index="node.mId" :name="node.mId">
                    <td style="text-align:left; width:1.5em; padding: 0;"
                      v-bind:class="{ 'ncut-row-selectd': node.mId == curID, '': node.mId != curID }"
                      @click="itemClick(node)">
                      <img src="@/assets/images/treeLine3.gif" style=" height: 1.5em;"  v-if="(menuInfo.length-1) > index" />
                      <img src="@/assets/images/blank.gif" style=" height: 1.5em;"  v-else />
                    </td>
                    <td style="text-align:left; width:1.5em; padding: 0;"
                      v-bind:class="{ 'ncut-row-selectd': node.mId == curID, '': node.mId != curID }"
                      @click="itemClick(node)">
                      <img src="@/assets/images/treeLine2.gif" style=" height: 1.5em;"  v-if="index2 == (items.subMenu.length - 1)" />
                      <img src="@/assets/images/treeLine.gif" style=" height: 1.5em;"  v-else />
                    </td>
                    <td style="text-align:left; width:21em; padding: padding: 0 0.5rem;"
                      v-bind:class="{ 'ncut-row-selectd': node.mId == curID, '': node.mId != curID }"
                      @click="itemClick(node)">                      
                      <table>
                        <tr>
                          <td>
                              <img class="tools-btn" style=" height: 1.25em;"  
                                src="@/assets/images/ic_format_color_text_black_24dp.png" />
                          </td>
                          <td>
                              <b-form-input placeholder="請輸入繁體選單名稱" style="width:20em"
                                    v-model="node.title[0]"
                                    size="small" maxlength="15" show-word-limit
                                    @change="setChangeFlag(node)"/>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td style="text-align:left; width:12em; padding: 0 0.5rem;"
                      v-bind:class="{ 'ncut-row-selectd': node.mId == curID, '': node.mId != curID }">
                      <b-form-radio-group
                        id="btn-radios-2"
                        v-model="node.sort"
                        @change="setChangeFlag(node)"
                        v-on:focus="itemClick(node)"
                        :options="options"
                        button-variant="outline-primary"
                        placeholder="請選擇..."
                        name="radio-btn-outline"
                        buttons
                      ></b-form-radio-group>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ncut-base-form-button"
        v-if="isChange">
        <b-button variant="success" tabindex="14"
          @click="save()"><b-icon icon="check-square"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as tools from '@/tool';
export default {
  name: 'menuSet',
  data () {
    return {
      menuInfo : null,
      setInfo : null,
      isChange : false,
      curID : 0,
      options: [
          { text: '不可執行', value: '0' },
          { text: '可執行', value: '1' }
      ]
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId;
    },
    setting () {
      return this.$store.getters.getSetting;
    },
  },
  methods: {
    itemClick(item) {
      item.flag=!item.flag;
      this.curID = item.mId;
      this.$forceUpdate();
    },
    setChangeFlag (item) {
      this.isChange = true;
      item.isChange = true;
    },
    checkSaveData () {
      let msg = ''

      if (!tools.isNull(this.menuInfo)) {
        var obj = null;
        var count = 0;
        for (var i = 0; i < this.menuInfo.length; i++) {
          if (this.menuInfo[i].isChange == true) {
            var elements = {
              sysId    : this.menuInfo[i].sysId,
              mId      : this.menuInfo[i].mId,
              title    : this.menuInfo[i].title,
              sort     : this.menuInfo[i].sort,
            };
            if (tools.isNull(obj)) {
              var arry1 = [elements];
              obj = arry1;
            }
            else {
              obj.push(elements);
            }
          }

          if (!tools.isNull(this.menuInfo[i].subMenu)) {
            for (var j = 0; j < this.menuInfo[i].subMenu.length; j++) {
              if (this.menuInfo[i].subMenu[j].isChange == true) {
                var elements = {
                  sysId    : this.menuInfo[i].subMenu[j].sysId,
                  mId      : this.menuInfo[i].subMenu[j].mId,
                  title    : this.menuInfo[i].subMenu[j].title,
                  sort     : this.menuInfo[i].subMenu[j].sort
                };
                if (tools.isNull(obj)) {
                  var arry1 = [elements];
                  obj = arry1;
                } else {
                  obj.push(elements);
                }
              }
            }
          }
        }

        if (tools.isNull(obj)) {
          msg = '請修改選單設定!';
        } else {
          this.setInfo = obj;
        }
      }
      return msg
    },
    save () {   
      let msg = this.checkSaveData()
      if (msg.length === 0) {
          this.$http.put('./WebApi/Setting/SetMenuData', this.setInfo)
            .then((response) => {
              if (response.data === true) {
                this.$message({
                  message: '恭喜您,存檔成功',
                  type: 'success'
                })
              }
              else {
                this.$message.error('對不起,存檔失敗')
              }
            })
            .catch(function (error) {
              this.$message.error('對不起,網路連線失敗' + error)
            })
      } else {
        this.$message.error('對不起,' + msg)
        return false
      } 
    },
    getMenuItem: function () {
      return this.$http
                 .get('./WebApi/Setting/GetMenuItem/'.concat(this.sysId));
    },
  },
  created () {
    console.log('=== created MenuMgtView ===')
    var vm = this
    this.$http.all([this.getMenuItem()])
      .then(vm.$http.spread(function (data1) {
        vm.menuInfo = data1.data
      }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
